import { Box ,Stack} from "@mui/material";
import { useState } from "react";
import CollapsibleSidePanel from "./CollapsibleSidePanel";
import MainContent from "./MainContent";

export default function DocumentSearchPage() {
  const [open, setOpen] = useState(true);
  const [selectedDoc,setSelectedDoc]=useState(null)

  return (
    // <Box display="flex" height="calc(100vh - 64px)" width='100vw'>
    <Box
      sx={{
        height: '100vh',
        width: '100vw',
        backgroundColor: '#fff',
        overflow: 'auto',
      }}
    >
         <Stack spacing={2} p={2}>
        {/* Header Row */}
        <Box display="flex" alignItems="start" justifyContent="space-between">
      {/* Left Collapsible Panel */}
      
      <CollapsibleSidePanel open={open} setOpen={setOpen} />

      {/* Right Content auto adjusts */}
      <MainContent selectedDoc={selectedDoc} setSelectedDoc={setSelectedDoc} />
      </Box>
      </Stack>
    </Box>
  );
}
